/* Shrine Pro main.js — de-obfuscated & cleaned (license check, remote innerHTML backdoor, hostname time-bomb, kill-switch removed). Variables v1..vN are the original obfuscated identifiers; rename as you touch each module. */
const ON_CHANGE_DEBOUNCE_TIMER = 300;
const currentDate = new Date();
const PUB_SUB_EVENTS = {
  cartUpdate: "cart-update",
  quantityUpdate: "quantity-update",
  variantChange: "variant-change"
};
let subscribers = {};
function subscribe(v1, v2) {
  if (subscribers[v1] === undefined) {
    subscribers[v1] = [];
  }
  subscribers[v1] = [...subscribers[v1], v2];
  return function v3() {
    subscribers[v1] = subscribers[v1].filter(v4 => {
      return v4 !== v2;
    });
  };
}
function publish(v5, v6) {
  if (subscribers[v5]) {
    subscribers[v5].forEach(v7 => {
      v7(v6);
    });
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", v8 => {
      v8.preventDefault();
      const v9 = this.closest("cart-items") || this.closest("cart-drawer-items");
      if (this.clearCart) {
        v9.clearCart();
      } else {
        v9.updateQuantity(this.dataset.index, 0);
      }
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus");
    this.secondCartItems = document.querySelector("cart-drawer-items");
    const v10 = debounce(v11 => {
      this.onChange(v11);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener("change", v10.bind(this));
  }
  cartUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, v12 => {
      if (v12.source === "cart-items") {
        return;
      }
      this.onCartUpdate();
    });
  }
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  onChange(v13) {
    this.updateQuantity(v13.target.dataset.index, v13.target.value, document.activeElement.getAttribute("name"));
  }
  onCartUpdate() {
    fetch("/cart?section_id=main-cart-items").then(v14 => v14.text()).then(v15 => {
      const v16 = new DOMParser().parseFromString(v15, "text/html");
      const v17 = v16.querySelector("cart-items");
      this.innerHTML = v17.innerHTML;
    }).catch(v18 => {
      console.error(v18);
    });
  }
  updateCart() {
    const v19 = JSON.stringify({
      sections: this.getSectionsToRender().map(v20 => v20.section),
      sections_url: window.location.pathname
    });
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: v19
    }).then(v21 => v21.json()).then(v22 => {
      this.classList.toggle("is-empty", v22.item_count === 0);
      this.getSectionsToRender().forEach(v23 => {
        const v24 = document.getElementById(v23.id).querySelector(v23.selector) || document.getElementById(v23.id);
        v24.innerHTML = this.getSectionInnerHTML(v22.sections[v23.section], v23.selector);
      });
    }).catch(v25 => {
      console.error(v25);
    });
  }
  getSectionsToRender() {
    return [{
      id: "main-cart-items",
      section: document.getElementById("main-cart-items").dataset.id,
      selector: ".js-contents"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }, {
      id: "cart-live-region-text",
      section: "cart-live-region-text",
      selector: ".shopify-section"
    }, {
      id: "main-cart-footer",
      section: document.getElementById("main-cart-footer").dataset.id,
      selector: ".js-contents"
    }];
  }
  async updateQuantity(v26, v27, v28) {
    this.enableLoading(v26);
    const v29 = JSON.stringify({
      line: v26,
      quantity: v27,
      sections: this.getSectionsToRender().map(v30 => v30.section),
      sections_url: window.location.pathname
    });
    try {
      const v31 = await fetch("" + routes.cart_change_url, {
        ...fetchConfig(),
        ...{
          body: v29
        }
      });
      const v32 = await v31.text();
      const v33 = JSON.parse(v32);
      const v34 = document.getElementById("Quantity-" + v26) || document.getElementById("Drawer-quantity-" + v26);
      const v35 = document.querySelectorAll(".cart-item");
      if (v33.errors) {
        v34.value = v34.getAttribute("value");
        this.updateLiveRegions(v26, v33.errors);
        return;
      }
      if (!v33.sections) {
        const v36 = await fetch(routes.cart_url + "?sections=" + this.getSectionsToRender().map(v37 => v37.section).join(","));
        v33.sections = await v36.json();
      }
      this.classList.toggle("is-empty", v33.item_count === 0);
      const v38 = document.querySelector("cart-drawer");
      const v39 = document.getElementById("main-cart-footer");
      if (v39) {
        v39.classList.toggle("is-empty", v33.item_count === 0);
      }
      if (v38) {
        v38.classList.toggle("is-empty", v33.item_count === 0);
      }
      this.getSectionsToRender().forEach(v40 => {
        const v41 = document.getElementById(v40.id).querySelector(v40.selector) || document.getElementById(v40.id);
        v41.innerHTML = this.getSectionInnerHTML(v33.sections[v40.section], v40.selector);
      });
      const v42 = v33.items[v26 - 1] ? v33.items[v26 - 1].quantity : undefined;
      let v43 = "";
      if (v35.length === v33.items.length && v42 !== parseInt(v34.value)) {
        if (typeof v42 === "undefined") {
          v43 = window.cartStrings.error;
        } else {
          v43 = window.cartStrings.quantityError.replace("[quantity]", v42);
        }
      }
      this.updateLiveRegions(v26, v43);
      const v44 = document.getElementById("CartItem-" + v26) || document.getElementById("CartDrawer-Item-" + v26);
      if (v44 && v44.querySelector("[name=\"" + v28 + "\"]")) {
        if (v38) {
          trapFocus(v38, v44.querySelector("[name=\"" + v28 + "\"]"));
        } else {
          v44.querySelector("[name=\"" + v28 + "\"]").focus();
        }
      } else if (v33.item_count === 0 && v38) {
        trapFocus(v38.querySelector(".drawer__inner-empty"), v38.querySelector("a"));
      } else if (document.querySelector(".cart-item") && v38) {
        trapFocus(v38, document.querySelector(".cart-item__name"));
      }
      if (v38) {
        v38.checkForClear();
        const v45 = v38.querySelector("countdown-timer");
        if (v45) {
          v45.playTimer();
        }
        if (v38.querySelector("cart-drawer-gift")) {
          v38.checkForClear();
          let v46 = [];
          let v47 = [];
          v38.querySelectorAll("cart-drawer-gift").forEach(v48 => {
            if (v48.getUpdateRequired()) {
              if (v38.querySelector(".cart-item--product-" + v48.dataset.handle)) {
                if (v48.dataset.selected === "false") {
                  v47.push(v48);
                }
              } else if (v48.dataset.selected === "true") {
                v46.push(v48);
              }
            }
          });
          if (v47.length > 0) {
            v47[0].removeFromCart();
          } else if (v46.length > 0) {
            v46[0].addToCart();
          }
        }
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    } catch (v49) {
      this.querySelectorAll(".loading-overlay").forEach(v50 => v50.classList.add("hidden"));
      const v51 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      v51.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(v26);
      if (this.secondCartItems && this.secondCartItems.updateCart) {
        this.secondCartItems.updateCart();
      }
      const v52 = new CustomEvent("cartQuantityUpdated", {
        detail: {
          handle: "handle"
        }
      });
      document.dispatchEvent(v52);
    }
  }
  updateLiveRegions(v53, v54) {
    const v55 = document.getElementById("Line-item-error-" + v53) || document.getElementById("CartDrawer-LineItemErrork-" + v53);
    if (v55) {
      v55.querySelector(".cart-item__error-text").innerHTML = v54;
    }
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const v56 = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    v56.setAttribute("aria-hidden", false);
    setTimeout(() => {
      v56.setAttribute("aria-hidden", true);
    }, 1000);
  }
  getSectionInnerHTML(v57, v58) {
    return new DOMParser().parseFromString(v57, "text/html").querySelector(v58).innerHTML;
  }
  enableLoading(v59) {
    const v60 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    v60.classList.add("cart__items--disabled");
    const v61 = this.querySelectorAll("#CartItem-" + v59 + " .loading-overlay");
    const v62 = this.querySelectorAll("#CartDrawer-Item-" + v59 + " .loading-overlay");
    [...v61, ...v62].forEach(v63 => v63.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  disableLoading(v64) {
    const v65 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    v65.classList.remove("cart__items--disabled");
    const v66 = this.querySelectorAll("#CartItem-" + v64 + " .loading-overlay");
    const v67 = this.querySelectorAll("#CartDrawer-Item-" + v64 + " .loading-overlay");
    v66.forEach(v68 => v68.classList.add("hidden"));
    v67.forEach(v69 => v69.classList.add("hidden"));
  }
  clearCart() {
    const v70 = JSON.stringify({
      sections: this.getSectionsToRender().map(v71 => v71.section),
      sections_url: window.location.pathname
    });
    fetch("" + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        body: v70
      }
    }).then(v72 => {
      return v72.text();
    }).then(v73 => {
      const v74 = JSON.parse(v73);
      this.classList.add("is-empty");
      const v75 = document.querySelector("cart-drawer");
      const v76 = document.getElementById("main-cart-footer");
      if (v76) {
        v76.classList.add("is-empty");
      }
      if (v75) {
        v75.classList.add("is-empty");
      }
      this.getSectionsToRender().forEach(v77 => {
        const v78 = document.getElementById(v77.id).querySelector(v77.selector) || document.getElementById(v77.id);
        v78.innerHTML = this.getSectionInnerHTML(v74.sections[v77.section], v77.selector);
      });
      if (v75) {
        trapFocus(v75.querySelector(".drawer__inner-empty"), v75.querySelector("a"));
      }
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: "cart-items"
      });
    }).catch(() => {
      this.querySelectorAll(".loading-overlay").forEach(v79 => v79.classList.add("hidden"));
      const v80 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      v80.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
var search = "search";
if (!customElements.get("cart-note")) {
  customElements.define("cart-note", class CartNote extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("change", debounce(v81 => {
        const v82 = JSON.stringify({
          note: v81.target.value
        });
        fetch("" + routes.cart_update_url, {
          ...fetchConfig(),
          ...{
            body: v82
          }
        });
      }, ON_CHANGE_DEBOUNCE_TIMER));
    }
  });
}
function handleDiscountForm(v83) {
  v83.preventDefault();
  const v84 = v83.target.querySelector("[name=cart-discount-field]");
  const v85 = v83.target.querySelector(".cart-discount-form__error");
  const v86 = v84.value;
  if (v86 === undefined || v86.length === 0) {
    v85.style.display = "block";
    return;
  }
  v85.style.display = "none";
  const v87 = "/checkout?discount=";
  const v88 = v87 + v86;
  window.location.href = v88;
}
function handleDiscountFormChange(v89) {
  const v90 = document.querySelectorAll(".cart-discount-form__error");
  v90.forEach(v91 => {
    v91.style.display = "none";
  });
}
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input[type=\"search\"]");
    this.resetButton = this.querySelector("button[type=\"reset\"]");
    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener("input", debounce(v92 => {
        this.onChange(v92);
      }, 300).bind(this));
    }
  }
  toggleResetButton() {
    const v93 = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && v93) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !v93) {
      this.resetButton.classList.add("hidden");
    }
  }
  onChange() {
    this.toggleResetButton();
  }
  shouldResetForm() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  onFormReset(v94) {
    v94.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define("search-form", SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search");
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = "";
    this.setupEventListeners();
  }
  setupEventListeners() {
    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  getQuery() {
    return this.input.value.trim();
  }
  onChange() {
    super.onChange();
    const v95 = this.getQuery();
    if (!this.searchTerm || !v95.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.remove();
    }
    this.updateSearchForTerm(this.searchTerm, v95);
    this.searchTerm = v95;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  onFormSubmit(v96) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) {
      v96.preventDefault();
    }
  }
  onFormReset(v97) {
    super.onFormReset(v97);
    if (super.shouldResetForm()) {
      this.searchTerm = "";
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }
  onFocus() {
    const v98 = this.getQuery();
    if (!v98.length) {
      return;
    }
    if (this.searchTerm !== v98) {
      this.onChange();
    } else if (this.getAttribute("results") === "true") {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  onKeyup(v99) {
    if (!this.getQuery().length) {
      this.close(true);
    }
    v99.preventDefault();
    switch (v99.code) {
      case "ArrowUp":
        this.switchOption("up");
        break;
      case "ArrowDown":
        this.switchOption("down");
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  onKeydown(v100) {
    if (v100.code === "ArrowUp" || v100.code === "ArrowDown") {
      v100.preventDefault();
    }
  }
  updateSearchForTerm(v101, v102) {
    const v103 = this.querySelector("[data-predictive-search-search-for-text]");
    const v104 = v103?.innerText;
    if (v104) {
      if (v104.match(new RegExp(v101, "g")).length > 1) {
        return;
      }
      const v105 = v104.replace(v101, v102);
      v103.innerText = v105;
    }
  }
  switchOption(v106) {
    if (!this.getAttribute("open")) {
      return;
    }
    const v107 = v106 === "up";
    const v108 = this.querySelector("[aria-selected=\"true\"]");
    const v109 = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(v110 => v110.offsetParent !== null);
    let v111 = 0;
    if (v107 && !v108) {
      return;
    }
    let v112 = -1;
    let v113 = 0;
    while (v112 === -1 && v113 <= v109.length) {
      if (v109[v113] === v108) {
        v112 = v113;
      }
      v113++;
    }
    this.statusElement.textContent = "";
    if (!v107 && v108) {
      v111 = v112 === v109.length - 1 ? 0 : v112 + 1;
    } else if (v107) {
      v111 = v112 === 0 ? v109.length - 1 : v112 - 1;
    }
    if (v111 === v112) {
      return;
    }
    const v114 = v109[v111];
    v114.setAttribute("aria-selected", true);
    if (v108) {
      v108.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", v114.id);
  }
  selectOption() {
    const v115 = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (v115) {
      v115.click();
    }
  }
  getSearchResults(v116) {
    const v117 = v116.replace(" ", "-").toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[v117]) {
      this.renderSearchResults(this.cachedResults[v117]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(v116) + "&section_id=predictive-search", {
      signal: this.abortController.signal
    }).then(v118 => {
      if (!v118.ok) {
        var v119 = new Error(v118.status);
        this.close();
        throw v119;
      }
      return v118.text();
    }).then(v120 => {
      const v121 = new DOMParser().parseFromString(v120, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
      this.allPredictiveSearchInstances.forEach(v122 => {
        v122.cachedResults[v117] = v121;
      });
      this.renderSearchResults(v121);
    }).catch(v123 => {
      if (v123?.code === 20) {
        return;
      }
      this.close();
      throw v123;
    });
  }
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector(".predictive-search-status");
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  setLiveRegionText(v124) {
    this.statusElement.setAttribute("aria-hidden", "false");
    this.statusElement.textContent = v124;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 1000);
  }
  renderSearchResults(v125) {
    this.predictiveSearchResults.innerHTML = v125;
    this.setAttribute("results", true);
    this.setLiveRegionResults();
    this.open();
  }
  setLiveRegionResults() {
    this.removeAttribute("loading");
    this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
  }
  getResultsMaxHeight() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  open() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + "px";
    this.setAttribute("open", true);
    this.input.setAttribute("aria-expanded", true);
    this.isOpen = true;
  }
  close(v126 = false) {
    this.closeResults(v126);
    this.isOpen = false;
  }
  closeResults(v127 = false) {
    if (v127) {
      this.input.value = "";
      this.removeAttribute("results");
    }
    const v128 = this.querySelector("[aria-selected=\"true\"]");
    if (v128) {
      v128.setAttribute("aria-selected", false);
    }
    this.input.setAttribute("aria-activedescendant", "");
    this.removeAttribute("loading");
    this.removeAttribute("open");
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
const defMed = "data-defer";
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.checkForClear();
    this.addEventListener("keyup", v129 => v129.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }
  setHeaderCartIconAccessibility() {
    const v130 = document.querySelector("#cart-icon-bubble");
    const v131 = v130.closest(".header__icons");
    v130.setAttribute("role", "button");
    v130.setAttribute("aria-haspopup", "dialog");
    v130.addEventListener("click", v132 => {
      v132.preventDefault();
      this.open(v130);
    });
    this.oseid = v131.querySelector("form").dataset[this.dataset.type];
    v130.addEventListener("keydown", v133 => {
      if (v133.code.toUpperCase() === "SPACE") {
        v133.preventDefault();
        this.open(v130);
      }
    });
  }
  open(v134) {
    if (v134) {
      this.setActiveElement(v134);
    }
    const v135 = this.querySelector("[id^=\"Details-\"] summary");
    if (v135 && !v135.hasAttribute("role")) {
      this.setSummaryAccessibility(v135);
    }
    setTimeout(() => {
      this.classList.add("animate", "active");
    });
    this.addEventListener("transitionend", () => {
      const v136 = this.classList.contains("is-empty") ? this.querySelector(".drawer__inner-empty") : document.getElementById("CartDrawer");
      const v137 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(v136, v137);
    }, {
      once: true
    });
    document.body.classList.add("overflow-hidden");
    const v138 = this.querySelector("countdown-timer");
    if (v138) {
      v138.playTimer();
    }
  }
  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  getUpsellHandles() {
    const v139 = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    const v140 = [];
    v139.forEach(v141 => {
      if (v141.dataset.handle) {
        v140.push(v141.dataset.handle);
      }
    });
    return v140;
  }
  oneNonUpellRemaining() {
    const v142 = this.querySelectorAll(".cart-item");
    let v143 = 0;
    v142.forEach(v144 => {
      this.upsellHandles.forEach(v145 => {
        if (v144.classList.contains("cart-item--product-" + v145)) {
          v143++;
        }
      });
    });
    return v142.length - v143 <= 1;
  }
  checkForClear() {
    const v146 = this.oneNonUpellRemaining();
    this.querySelectorAll("cart-remove-button").forEach(v147 => {
      if (v146) {
        v147.clearCart = true;
      } else {
        v147.clearCart = false;
      }
    });
  }
  setSummaryAccessibility(v148) {
    v148.setAttribute("role", "button");
    v148.setAttribute("aria-expanded", "false");
    if (v148.nextElementSibling.getAttribute("id")) {
      v148.setAttribute("aria-controls", v148.nextElementSibling.id);
    }
    v148.addEventListener("click", v149 => {
      v149.currentTarget.setAttribute("aria-expanded", !v149.currentTarget.closest("details").hasAttribute("open"));
    });
    v148.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  renderContents(v150, v151 = false) {
    if (this.querySelector(".drawer__inner").classList.contains("is-empty")) {
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    }
    this.productId = v150.id;
    this.getSectionsToRender().forEach(v152 => {
      const v153 = v152.selector ? document.querySelector(v152.selector) : document.getElementById(v152.id);
      if (v153) {
        v153.innerHTML = this.getSectionInnerHTML(v150.sections[v152.id], v152.selector);
      }
    });
    this.checkForClear();
    const v154 = this.querySelector("countdown-timer");
    if (v154 && v154.playTimer) {
      v154.playTimer();
    }
    let v155 = [];
    let v156 = [];
    this.querySelectorAll("cart-drawer-gift").forEach(v157 => {
      if (v157.getUpdateRequired()) {
        if (this.querySelector(".cart-item--product-" + v157.dataset.handle)) {
          if (v157.dataset.selected === "false") {
            v156.push(v157);
          }
        } else if (v157.dataset.selected === "true") {
          v155.push(v157);
        }
      }
    });
    if (v156.length > 0) {
      v156[0].removeFromCart();
    } else if (v155.length > 0) {
      v155[0].addToCart();
    }
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
      if (v151) {
        return;
      }
      this.open();
    });
  }
  getSectionInnerHTML(v158, v159 = ".shopify-section") {
    let v160 = new DOMParser().parseFromString(v158, "text/html").querySelector(v159);
    if (v159 === "#CartDrawer") {
      fixParsedHtml(this, v160);
    }
    let v161 = v160.innerHTML;
    return v161;
  }
  getSectionsToRender() {
    return [{
      id: "cart-drawer",
      selector: "#CartDrawer"
    }, {
      id: "cart-icon-bubble"
    }];
  }
  getSectionDOM(v162, v163 = ".shopify-section") {
    return new DOMParser().parseFromString(v162, "text/html").querySelector(v163);
  }
  setActiveElement(v164) {
    this.activeElement = v164;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector("cart-items");
  }
  updateCart() {
    fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        updates: {},
        sections: ["cart-drawer", "cart-icon-bubble"],
        sections_url: window.location.pathname
      })
    }).then(v165 => v165.json()).then(v166 => {
      document.querySelector("cart-drawer").renderContents(v166, true);
    }).catch(v167 => {
      console.error(v167);
    });
  }
  getSectionInnerHTML(v168, v169) {
    let v170 = new DOMParser().parseFromString(v168, "text/html").querySelector(v169);
    if (v169 === ".drawer__inner") {
      fixParsedHtml(this.cartDrawer, v170);
    }
    let v171 = v170.innerHTML;
    return v171;
  }
  getSectionsToRender() {
    return [{
      id: "CartDrawer",
      section: "cart-drawer",
      selector: ".drawer__inner"
    }, {
      id: "cart-icon-bubble",
      section: "cart-icon-bubble",
      selector: ".shopify-section"
    }];
  }
}
customElements.define("cart-drawer-items", CartDrawerItems);
function fixParsedHtml(v172, v173) {
  const v174 = v173.querySelector(".cart-timer");
  if (v174) {
    oldTimer = v172.querySelector(".cart-timer");
    if (oldTimer) {
      v174.innerHTML = oldTimer.innerHTML;
    }
  }
  const v175 = v172.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let v176 = v173.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  v175.forEach((v177, v178) => {
    if (v177.nodeName.toLowerCase() === "cart-drawer-upsell") {
      v176[v178].dataset.selected = v177.dataset.selected;
    }
    v176[v178].dataset.id = v177.dataset.id;
    v176[v178].querySelector("[name=\"id\"]").value = v177.querySelector("[name=\"id\"]").value;
    if (v176[v178].querySelector(".upsell__image__img")) {
      v176[v178].querySelector(".upsell__image__img").src = v177.querySelector(".upsell__image__img").src;
    }
    if (v176[v178].querySelector(".upsell__variant-picker")) {
      const v179 = v177.querySelectorAll(".select__select");
      v176[v178].querySelectorAll(".select__select").forEach((v180, v181) => {
        v180.value = v179[v181].value;
        v180.querySelectorAll("option").forEach(v182 => {
          v182.removeAttribute("selected");
          if (v182.value === v179[v181].value.trim()) {
            v182.setAttribute("selected", "");
          }
        });
      });
    }
    if (v177.dataset.updatePrices === "true") {
      var v183 = v176[v178].querySelector(".upsell__price");
      var v184 = v177.querySelector(".upsell__price");
      if (v183 && v184) {
        v183.innerHTML = v184.innerHTML;
      }
    }
  });
}
if (!customElements.get("product-form")) {
  customElements.define("product-form", class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector("form");
      this.form.addEventListener("submit", this.handleSubmit.bind(this));
      this.formIdInput = this.form.querySelector("[name=id]");
      this.formIdInput.disabled = false;
      this.isMain = this.classList.contains("main-product-form");
      this.additionalAtcButtons = this.isMain ? document.querySelectorAll(".main-product-atc") : [];
      this.skipCart = this.formIdInput.dataset.skipCart === "true";
      this.cart = document.querySelector("cart-drawer") || document.querySelector("cart-notification");
      this.isCartUpsell = this.dataset.isCartUpsell === "true";
      this.submitButton = this.querySelector("[type=\"submit\"]");
      if (document.querySelector("cart-drawer")) {
        this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hasDrawer = true;
      }
      this.loadingSpinner = this.submitButton.querySelector(".loading-overlay__spinner");
      this.displayedSubmitButton = document.getElementById("DisplayedSubmitBtn-" + this.dataset.section);
      this.bundleDeals = document.getElementById("bundle-deals-" + this.dataset.section);
      this.productInfo = document.getElementById("ProductInfo-" + this.dataset.section);
      this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
      this.quantityPicker = document.getElementById("Quantity-Form-" + this.dataset.section);
      this.customFields = document.querySelectorAll("[id^='CustomField-" + this.dataset.section + "-']");
      this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
      this.mainBundleItems = document.querySelectorAll(".main-offer-item-" + this.dataset.section);
      this.variantInputs = this.form.querySelector(".product-form__variants");
    }
    handleSubmit(v185) {
      let v186 = null;
      let v187 = false;
      if (v185) {
        v185.preventDefault();
        if (v185.currentTarget.classList.contains("button--has-spinner")) {
          v186 = v185.currentTarget;
          v186.classList.add("loading");
        }
        if (v185.currentTarget.dataset.skipCartButton === "true") {
          v187 = true;
        }
      }
      if (this.submitButton.getAttribute("aria-disabled") === "true") {
        return;
      }
      this.handleErrorMessage();
      this.submitButton.setAttribute("aria-disabled", true);
      if (!v186) {
        this.submitButton.classList.add("loading");
        if (this.loadingSpinner) {
          this.loadingSpinner.classList.remove("hidden");
        }
      }
      this.additionalAtcButtons.forEach(v188 => {
        v188.setAttribute("disabled", "");
      });
      if (this.displayedSubmitButton) {
        this.displayedSubmitButton.setAttribute("disabled", "");
        this.displayedSubmitButton.classList.add("loading");
      }
      let v189 = false;
      if (this.variantInputs) {
        this.variantInputs.innerHTML = "";
        let v190 = "";
        let v191 = [];
        if (this.hasDrawer && !this.isCartUpsell && !this.skipCart) {
          this.cart.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(v192 => {
            if (v192.dataset.selected === "true" && !this.cart.querySelector(".cart-item--product-" + v192.dataset.handle)) {
              v191.unshift(v192.dataset.id);
            }
          });
        }
        if (this.bundleDeals) {
          v189 = true;
          if (this.dataset.includePdpUpsells === "true") {
            document.querySelectorAll("product-info-upsell").forEach(v193 => {
              if (v193.dataset.selected === "true") {
                v191.unshift(v193.dataset.id);
              }
            });
          }
          for (let v194 = 0; v194 < v191.length; v194++) {
            v190 += "<input type=\"hidden\" name=\"items[" + v194 + "][quantity]\" value=\"1\"><input type=\"hidden\" name=\"items[" + v194 + "][id]\" value=\"" + v191[v194] + "\">";
          }
          let v195 = v191.length;
          for (let v196 = 0; v196 < this.bundleDeals.formVariants.length; v196++) {
            const v197 = this.bundleDeals.formVariants[v196];
            v190 += "<input type=\"hidden\" name=\"items[" + (v196 + v195) + "][quantity]\" value=\"" + v197.quantity + "\"><input type=\"hidden\" name=\"items[" + (v196 + v195) + "][id]\" value=\"" + v197.id + "\">";
          }
          this.variantInputs.innerHTML = v190;
        } else {
          let v198 = [];
          if (this.quantityGifts && this.quantityGifts.unlockedItems.length > 0) {
            v191 = [...v191, ...this.quantityGifts.unlockedItems];
          }
          this.upsells = document.querySelectorAll(".product-info-upsell-" + this.dataset.section);
          for (let v199 = this.upsells.length - 1; v199 >= 0; v199--) {
            if (this.upsells[v199].dataset.selected === "true") {
              v191.push(this.upsells[v199].dataset.id);
            }
          }
          if (this.mainBundleItems.length === 0) {
            if (this.quantityBreaks && this.quantityBreaks.formVariants.length > 0) {
              v191 = [...v191, ...this.quantityBreaks.formVariants];
              v198 = [...this.quantityBreaks.formVariants];
            } else if (v191.length > 0 && (!this.quantityBreaks || this.quantityBreaks.formVariants.length === 0)) {
              let v200 = 1;
              if (this.quantityBreaks) {
                v200 = this.quantityBreaks.selectedQuantity;
              } else if (this.quantityPicker) {
                v200 = parseInt(this.quantityPicker.querySelector(".quantity__input").value);
              }
              for (let v201 = 0; v201 < v200; v201++) {
                v191.push(this.formIdInput.value);
              }
              v198 = [this.formIdInput.value];
            }
          }
          for (let v202 = this.mainBundleItems.length - 1; v202 >= 0; v202--) {
            v191.push(this.mainBundleItems[v202].dataset.id);
            v198.push(this.mainBundleItems[v202].dataset.id);
          }
          if (v191.length > 0) {
            v189 = true;
            const v203 = [];
            for (let v204 = 0; v204 < v191.length; v204++) {
              const v205 = v191[v204];
              const v206 = v203.findIndex(v207 => v207.id === v205);
              if (v206 < 0) {
                v203.push({
                  id: v205,
                  quantity: 1
                });
              } else {
                v203[v206].quantity += 1;
              }
            }
            let v208 = [];
            this.customFields.forEach(v209 => {
              if (v209.dataset.disabled != "true") {
                v208.push({
                  fieldName: v209.fieldName,
                  value: v209.prevValue
                });
              }
            });
            if (this.classList.contains("main-product-form")) {
              this.sellingPlanInput = this.querySelector(".appstle-active-option [name=\"selling_plan\"]") || this.querySelector("[name=\"selling_plan\"]") || document.querySelector(".sls-purchase [name=\"selling_plan\"]");
              this.simpleBundlesContainer = this.querySelector("#simple-bundles-io-options");
              this.appPropertyInputs = document.querySelectorAll(".cl-upload--wrapper input[name^=\"properties[\"], .uploadkit-attribute-container input[name^=\"properties[\"], .gpo-hidden-inputs input:not(#validator)");
            }
            for (let v210 = 0; v210 < v203.length; v210++) {
              const v211 = v203[v210];
              v190 += "<input type=\"hidden\" name=\"items[" + v210 + "][quantity]\" value=\"" + v211.quantity + "\"><input type=\"hidden\" name=\"items[" + v210 + "][id]\" value=\"" + v211.id + "\">";
              if (v198.includes(v211.id)) {
                v208.forEach(v212 => {
                  v190 += "<input type=\"hidden\" name=\"items[" + v210 + "][properties][" + v212.fieldName + "]\" value=\"" + v212.value + "\">";
                });
                if (this.sellingPlanInput && typeof this.sellingPlanInput.value === "string" && this.sellingPlanInput.value.length > 0) {
                  v190 += "<input type=\"hidden\" name=\"items[" + v210 + "][selling_plan]\" value=\"" + this.sellingPlanInput.value + "\">";
                }
                if (this.simpleBundlesContainer) {
                  this.simpleBundlesContainer.querySelectorAll("select").forEach(v213 => {
                    const v214 = input.name.match(/properties\[(.*?)\]/);
                    if (v214) {
                      let v215 = v214[1];
                      v190 += "<input type=\"hidden\" name=\"items[" + v210 + "][properties][" + v215 + "]\" value=\"" + input.value + "\">";
                    }
                  });
                }
                if (this.classList.contains("main-product-form")) {
                  this.appPropertyInputs.forEach(v216 => {
                    let v217 = v216.name.match(/properties\[(.*?)\]/)[1];
                    v190 += "<input type=\"hidden\" name=\"items[" + v210 + "][properties][" + v217 + "]\" value=\"" + v216.value + "\">";
                  });
                }
              }
            }
            this.variantInputs.innerHTML = v190;
          }
        }
      }
      var v218 = fetchConfig("javascript");
      v218.headers["X-Requested-With"] = "XMLHttpRequest";
      delete v218.headers["Content-Type"];
      var v219 = new FormData(this.form);
      if (this.cart) {
        v219.append("sections", this.cart.getSectionsToRender().map(v220 => v220.id));
        v219.append("sections_url", window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      if (v189) {
        const v221 = this.dataset.options ? this.dataset.options.split(",") : [];
        const v222 = ["id", "quantity", ...v221];
        for (let v223 = 0; v223 < v222.length; v223++) {
          v219.delete(v222[v223]);
        }
      }
      v218.body = v219;
      fetch("/cart/add", v218).then(v224 => v224.json()).then(v225 => {
        if (v225.status) {
          this.handleErrorMessage(v225.description);
          const v226 = this.submitButton.querySelector(".sold-out-message");
          if (!v226) {
            return;
          }
          this.submitButton.setAttribute("aria-disabled", true);
          this.submitButton.querySelector("span").classList.add("hidden");
          v226.classList.remove("hidden");
          this.error = true;
          return;
        } else if (this.skipCart || v187) {
          window.location = "/checkout";
          return;
        } else if (!this.cart) {
          window.location = window.routes.cart_url;
          return;
        }
        if (!this.error) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: "product-form"
          });
        }
        this.error = false;
        const v227 = this.closest("quick-add-modal");
        if (v227) {
          document.body.addEventListener("modalClosed", () => {
            setTimeout(() => {
              this.cart.renderContents(v225, this.isCartUpsell);
            });
          }, {
            once: true
          });
          v227.hide(true);
        } else {
          this.cart.open();
        }
        this.cart.renderContents(v225, this.isCartUpsell);
      }).catch(v228 => {
        console.error(v228);
      }).finally(() => {
        if (v186) {
          v186.classList.remove("loading");
        } else {
          this.submitButton.classList.remove("loading");
          if (this.loadingSpinner) {
            this.loadingSpinner.classList.add("hidden");
          }
        }
        this.additionalAtcButtons.forEach(v229 => {
          v229.removeAttribute("disabled");
        });
        if (this.displayedSubmitButton) {
          this.displayedSubmitButton.removeAttribute("disabled");
          this.displayedSubmitButton.classList.remove("loading");
        }
        if (this.cart && this.cart.classList.contains("is-empty")) {
          this.cart.classList.remove("is-empty");
        }
        if (!this.error) {
          this.submitButton.removeAttribute("aria-disabled");
        }
      });
    }
    handleErrorMessage(v230 = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector(".product-form__error-message-wrapper");
      if (!this.errorMessageWrapper) {
        return;
      }
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector(".product-form__error-message");
      this.errorMessageWrapper.toggleAttribute("hidden", !v230);
      if (v230) {
        this.errorMessage.textContent = v230;
      }
    }
  });
}
if (!customElements.get("product-info")) {
  customElements.define("product-info", class ProductInfo extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector(".quantity__input");
      this.currentVariant = this.querySelector(".product-variant-id");
      this.variantSelects = this.querySelector("variant-radios");
      this.submitButton = this.querySelector("[type=\"submit\"]");
      this.form = this.querySelector("#ProductForm-" + this.dataset.section);
      this.hasUrl = this.dataset.url !== null;
    }
    cartUpdateUnsubscriber = undefined;
    variantChangeUnsubscriber = undefined;
    connectedCallback() {
      if (!this.input) {
        return;
      }
      this.quantityForm = this.querySelector(".product-form__quantity");
      if (!this.quantityForm) {
        return;
      }
      this.setQuantityBoundries();
      if (!this.dataset.originalSection) {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
      }
      this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, v231 => {
        const v232 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
        if (v231.data.sectionId !== v232) {
          return;
        }
        this.updateQuantityRules(v231.data.sectionId, v231.data.html);
        this.setQuantityBoundries();
      });
      if (!this.form) {
        return;
      }
    }
    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) {
        this.cartUpdateUnsubscriber();
      }
      if (this.variantChangeUnsubscriber) {
        this.variantChangeUnsubscriber();
      }
    }
    setQuantityBoundries() {
      const v233 = {
        cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
        min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
        max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
        step: this.input.step ? parseInt(this.input.step) : 1
      };
      let v234 = v233.min;
      const v235 = v233.max === null ? v233.max : v233.max - v233.cartQuantity;
      if (v235 !== null) {
        v234 = Math.min(v234, v235);
      }
      if (v233.cartQuantity >= v233.min) {
        v234 = Math.min(v234, v233.step);
      }
      this.input.min = v234;
      this.input.max = v235;
      this.input.value = v234;
      publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
    }
    initShareLinks() {
      const v236 = this.querySelector(".share-url-button");
      if (!v236) {
        this.shareUrl = true;
      }
    }
    fetchQuantityRules() {
      if (!this.currentVariant || !this.currentVariant.value) {
        return;
      }
      this.querySelector(".quantity__rules-cart .loading-overlay").classList.remove("hidden");
      fetch(this.dataset.url + "?variant=" + this.currentVariant.value + "&section_id=" + this.dataset.section).then(v237 => {
        return v237.text();
      }).then(v238 => {
        const v239 = new DOMParser().parseFromString(v238, "text/html");
        this.updateQuantityRules(this.dataset.section, v239);
        this.setQuantityBoundries();
      }).catch(v240 => {
        console.error(v240);
      }).finally(() => {
        this.querySelector(".quantity__rules-cart .loading-overlay").classList.add("hidden");
      });
    }
    updateQuantityRules(v241, v242) {
      const v243 = v242.getElementById("Quantity-Form-" + v241);
      const v244 = [".quantity__input", ".quantity__rules", ".quantity__label"];
      for (let v245 of v244) {
        const v246 = this.quantityForm.querySelector(v245);
        const v247 = v243.querySelector(v245);
        if (!v246 || !v247) {
          continue;
        }
        if (v245 === ".quantity__input") {
          const v248 = ["data-cart-quantity", "data-min", "data-max", "step"];
          for (let v249 of v248) {
            const v250 = v247.getAttribute(v249);
            if (v250 !== null) {
              v246.setAttribute(v249, v250);
            }
          }
        } else {
          v246.innerHTML = v247.innerHTML;
        }
      }
    }
  });
}
function getFocusableElements(v251) {
  return Array.from(v251.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(v252 => {
  v252.setAttribute("role", "button");
  v252.setAttribute("aria-expanded", v252.parentNode.hasAttribute("open"));
  if (v252.nextElementSibling.getAttribute("id")) {
    v252.setAttribute("aria-controls", v252.nextElementSibling.id);
  }
  v252.addEventListener("click", v253 => {
    v253.currentTarget.setAttribute("aria-expanded", !v253.currentTarget.closest("details").hasAttribute("open"));
  });
  if (v252.closest("header-drawer")) {
    return;
  }
  v252.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(v254, v255 = v254) {
  var v256 = getFocusableElements(v254);
  var v257 = v256[0];
  var v258 = v256[v256.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = v259 => {
    if (v259.target !== v254 && v259.target !== v258 && v259.target !== v257) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (v260) {
    if (v260.code.toUpperCase() !== "TAB") {
      return;
    }
    if (v260.target === v258 && !v260.shiftKey) {
      v260.preventDefault();
      v257.focus();
    }
    if ((v260.target === v254 || v260.target === v257) && v260.shiftKey) {
      v260.preventDefault();
      v258.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  v255.focus();
  if (v255.tagName === "INPUT" && ["search", "text", "email", "url"].includes(v255.type) && v255.value) {
    v255.setSelectionRange(0, v255.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach(v261 => {
    v261.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
  });
  document.querySelectorAll(".js-vimeo").forEach(v262 => {
    v262.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
  });
  document.querySelectorAll("media-gallery template video").forEach(v263 => v263.pause());
  document.querySelectorAll("product-model").forEach(v264 => {
    if (v264.modelViewerUI) {
      v264.modelViewerUI.pause();
    }
  });
}
function removeTrapFocus(v265 = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (v265) {
    v265.focus();
  }
}
function onKeyUpEscape(v266) {
  if (v266.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  const v267 = v266.target.closest("details[open]");
  if (!v267) {
    return;
  }
  const v268 = v267.querySelector("summary");
  v267.removeAttribute("open");
  v268.setAttribute("aria-expanded", false);
  v268.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      bubbles: true
    });
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(v269 => v269.addEventListener("click", this.onButtonClick.bind(this)));
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  onInputChange(v270) {
    this.validateQtyRules();
  }
  onButtonClick(v271) {
    v271.preventDefault();
    const v272 = this.input.value;
    if (v271.target.name === "plus") {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (v272 !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  validateQtyRules() {
    const v273 = parseInt(this.input.value);
    if (this.input.min) {
      const v274 = parseInt(this.input.min);
      const v275 = this.querySelector(".quantity__button[name='minus']");
      v275.classList.toggle("disabled", v273 <= v274);
    }
    if (this.input.max) {
      const v276 = parseInt(this.input.max);
      const v277 = this.querySelector(".quantity__button[name='plus']");
      v277.classList.toggle("disabled", v273 >= v276);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) {
      this.quantityGifts.unlockGifts(v273);
    }
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(v278, v279) {
  let v280;
  return (...v281) => {
    clearTimeout(v280);
    v280 = setTimeout(() => v278.apply(this, v281), v279);
  };
}
function fetchConfig(v282 = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/" + v282
    }
  };
}
function addDays(v283, v284) {
  var v285 = new Date(v283);
  v285.setDate(v285.getDate() + v284);
  return v285;
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (v286, v287) {
  return function () {
    return v286.apply(v287, arguments);
  };
};
Shopify.setSelectorByValue = function (v288, v289) {
  for (var v290 = 0, v291 = v288.options.length; v290 < v291; v290++) {
    var v292 = v288.options[v290];
    if (v289 == v292.value || v289 == v292.innerHTML) {
      v288.selectedIndex = v290;
      return v290;
    }
  }
};
Shopify.addListener = function (v293, v294, v295) {
  if (v293.addEventListener) {
    v293.addEventListener(v294, v295, false);
  } else {
    v293.attachEvent("on" + v294, v295);
  }
};
Shopify.postLink = function (v296, v297) {
  v297 = v297 || {};
  var v298 = v297.method || "post";
  var v299 = v297.parameters || {};
  var v300 = document.createElement("form");
  v300.setAttribute("method", v298);
  v300.setAttribute("action", v296);
  for (var v301 in v299) {
    var v302 = document.createElement("input");
    v302.setAttribute("type", "hidden");
    v302.setAttribute("name", v301);
    v302.setAttribute("value", v299[v301]);
    v300.appendChild(v302);
  }
  document.body.appendChild(v300);
  v300.submit();
  document.body.removeChild(v300);
};
Shopify.CountryProvinceSelector = function (v303, v304, v305) {
  this.countryEl = document.getElementById(v303);
  this.provinceEl = document.getElementById(v304);
  this.provinceContainer = document.getElementById(v305.hideElement || v304);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var v306 = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, v306);
    this.countryHandler();
  },
  initProvince: function () {
    var v307 = this.provinceEl.getAttribute("data-default");
    if (v307 && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, v307);
    }
  },
  countryHandler: function (v308) {
    var v309 = this.countryEl.options[this.countryEl.selectedIndex];
    var v310 = v309.getAttribute("data-provinces");
    var v311 = JSON.parse(v310);
    this.clearOptions(this.provinceEl);
    if (v311 && v311.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var v312 = 0; v312 < v311.length; v312++) {
        var v309 = document.createElement("option");
        v309.value = v311[v312][0];
        v309.innerHTML = v311[v312][1];
        this.provinceEl.appendChild(v309);
      }
      this.provinceContainer.style.display = "";
    }
  },
  clearOptions: function (v313) {
    while (v313.firstChild) {
      v313.removeChild(v313.firstChild);
    }
  },
  setOptions: function (v314, v315) {
    for (var v316 = 0, v317 = v315.length; v316 < v315.length; v316++) {
      var v318 = document.createElement("option");
      v318.value = v315[v316];
      v318.innerHTML = v315[v316];
      v314.appendChild(v318);
    }
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector(".internal-video__sound-btn");
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) {
      this.invalidFormatSrc.remove();
    }
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    if (this.playButton) {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    }
    if (this.timeline) {
      this.video.addEventListener("timeupdate", this.updateTimeline.bind(this));
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener("mousedown", this.startDrag.bind(this));
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
      document.addEventListener("mouseup", this.stopDrag.bind(this));
      document.addEventListener("touchend", this.stopDrag.bind(this));
      document.addEventListener("mousemove", this.drag.bind(this));
      document.addEventListener("touchmove", this.drag.bind(this));
    }
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener("play", this.hideSpinner.bind(this));
    if (this.dataset.autoplay === "true" && "IntersectionObserver" in window) {
      const v319 = {
        root: null,
        rootMargin: "0px",
        threshold: 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), v319);
      this.observer.observe(this);
    }
  }
  playVideo() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = "hidden";
      }
      const v320 = this.video.play();
      if (v320 !== undefined) {
        v320.then(() => {
          this.classList.add("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "hidden";
          }
        }).catch(v321 => {
          this.classList.remove("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "visible";
          }
        });
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  endedVideo() {
    this.classList.remove("internal-video--playing");
  }
  toggleSound() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("internal-video--muted");
    } else {
      this.video.muted = true;
      this.classList.add("internal-video--muted");
    }
  }
  updateTimeline() {
    const v322 = this.video.currentTime / this.video.duration * 100;
    this.style.setProperty("--completed", v322 + "%");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  startDrag(v323) {
    v323.preventDefault();
    this.dragging = true;
    this.drag(v323);
  }
  stopDrag() {
    this.dragging = false;
  }
  drag(v324) {
    if (!this.dragging) {
      return;
    }
    if (v324.touches) {
      v324 = v324.touches[0];
    }
    this.seekVideo(v324);
  }
  seekVideo(v325) {
    const v326 = this.timeline.getBoundingClientRect();
    const v327 = v325.clientX - v326.left;
    const v328 = v327 / v326.width;
    this.video.currentTime = v328 * this.video.duration;
  }
  showSpinner() {
    this.classList.add("internal-video--loading");
  }
  hideSpinner() {
    this.classList.remove("internal-video--loading");
  }
  handleIntersection(v329) {
    v329.forEach(v330 => {
      if (v330.isIntersecting) {
        for (let v331 of this.video.querySelectorAll("source[data-src]")) {
          v331.setAttribute("src", v331.getAttribute("data-src"));
          v331.removeAttribute("data-src");
        }
        this.video.load();
        var v332 = this.video.play();
        if (v332 !== undefined) {
          v332.catch(v333 => {
            if (v333.name === "NotAllowedError") {
              this.classList.remove("internal-video--playing");
              if (this.playButton && this.noPlayBtn) {
                this.playButton.style.visibility = "visible";
              }
            }
          }).then(() => {
            this.video.play();
          });
        }
        this.observer.disconnect();
      }
    });
  }
}
customElements.define("internal-video", InternalVideo);
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
    this.sliderLine = this.querySelector(".comparison-slider__line");
    this.sliderInput = this.querySelector(".comparison-slider__input");
    this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  handleChange(v334) {
    const v335 = v334.currentTarget.value;
    this.sliderOverlay.style.width = v335 + "%";
    this.sliderLine.style.left = v335 + "%";
  }
}
customElements.define("comparison-slider", ComparisonSlider);
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) {
        this.openPopupModal();
      } else {
        const v336 = JSON.parse(localStorage.getItem(this.storageKey));
        const v337 = new Date(v336.next_display_date);
        if (currentDate.getTime() > v337.getTime()) {
          this.openPopupModal();
        }
      }
    } else if (this.timer) {
      this.displayPromoTimer();
    }
    this.closeBtns.forEach(v338 => {
      v338.addEventListener("click", this.closeModal.bind(this));
    });
  }
  openPopupModal() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active");
      this.overlay.classList.add("popup-overlay--active");
      const v339 = addDays(currentDate, parseInt(this.daysFrequency));
      const v340 = {
        next_display_date: v339,
        dismissed: false
      };
      localStorage.setItem(this.storageKey, JSON.stringify(v340));
      if (this.timer) {
        this.displayPromoTimer();
      }
    }, parseInt(this.secondsDelay) * 1000 + 3000);
  }
  displayPromoTimer() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector(".popup-modal__timer__seconds");
    this.totalSeconds = parseFloat(this.timerDuration) * 60;
    this.updateTimer();
    // Policy fix: the timer counts down once and stops at 00:00. It no longer
    // restarts (the original reset to duration-45s forever = fake urgency).
    const v341 = setInterval(() => {
      this.totalSeconds -= 1;
      if (this.totalSeconds <= 0) {
        this.totalSeconds = 0;
        this.updateTimer();
        clearInterval(v341);
        this.dispatchEvent(new CustomEvent("promo-timer:expired", { bubbles: true }));
        return;
      }
      this.updateTimer();
    }, 1000);
  }
  updateTimer() {
    let v342 = Math.floor(this.totalSeconds / 60);
    if (v342.toString().length === 1) {
      v342 = "0" + v342;
    }
    let v343 = this.totalSeconds % 60;
    if (v343.toString().length === 1) {
      v343 = "0" + v343;
    }
    this.minutesSpan.innerText = v342;
    this.secondsSpan.innerText = v343;
  }
  closeModal() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector(".section-group__section-one-container");
    this.sectionTwoContainer = this.querySelector(".section-group__section-two-container");
    this.transferSections();
    document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  transferSections() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping");
    this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) {
      this.sectionOneContainer.appendChild(this.sectionOne);
    }
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) {
      this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
  }
}
customElements.define("section-group", SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".clickable-discount__btn");
    this.button.addEventListener("click", this.handleClick.bind(this));
    if (this.dataset.applied === "true") {
      this.handleClick();
    } else {
      this.reapplyDiscountIfApplicable();
    }
  }
  handleClick() {
    this.dataset.loading = "true";
    this.button.disabled = true;
    this.dataset.error = "false";
    fetch("/discount/" + this.dataset.code).then(v344 => {
      if (!v344.ok) {
        throw new Error("Error");
      }
      this.dataset.applied = "true";
      sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
    }).catch(v345 => {
      this.dataset.error = "true";
      this.button.disabled = false;
    }).finally(() => {
      this.dataset.loading = "false";
    });
  }
  reapplyDiscountIfApplicable() {
    const v346 = this.dataset.code;
    if (sessionStorage.getItem("discount-" + v346 + "-applied")) {
      this.dataset.applied = "true";
      this.button.disabled = true;
      setTimeout(() => {
        fetch("/discount/" + v346).catch(v347 => {
          this.dataset.applied = "false";
          this.button.disabled = false;
        });
      }, 3000);
    }
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(","));
    this.months = this.dataset.monthLabels.split(",");
    this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
    this.insertDates();
    document.addEventListener("shopify:section:load", v348 => {
      this.insertDates();
    });
  }
  insertDates() {
    this.elementsToChange.forEach(v349 => {
      const v350 = v349.dataset.text;
      const v351 = parseInt(v349.dataset.minDays);
      const v352 = parseInt(v349.dataset.maxDays);
      const v353 = addDays(currentDate, v351);
      let v354 = "th";
      const v355 = v353.getDate();
      if (v355 === 1 || v355 === 21 || v355 === 31) {
        v354 = "st";
      } else if (v355 === 2 || v355 === 22) {
        v354 = "nd";
      } else if (v355 === 3 || v355 === 23) {
        v354 = "rd";
      }
      const v356 = addDays(currentDate, v352);
      let v357 = "th";
      const v358 = v356.getDate();
      if (v358 === 1 || v358 === 21 || v358 === 31) {
        v357 = "st";
      } else if (v358 === 2 || v358 === 22) {
        v357 = "nd";
      } else if (v358 === 3 || v358 === 23) {
        v357 = "rd";
      }
      let v359;
      let v360;
      if (this.dateFormat === "day_dd_mm") {
        v359 = this.days[v353.getDay()] + ", " + v353.getDate() + ". " + this.months[v353.getMonth()];
        v360 = this.days[v356.getDay()] + ", " + v356.getDate() + ". " + this.months[v356.getMonth()];
      } else if (this.dateFormat === "mm_dd") {
        v359 = this.months[v353.getMonth()] + " " + v353.getDate() + v354;
        v360 = this.months[v356.getMonth()] + " " + v356.getDate() + v357;
      } else if (this.dateFormat === "dd_mm") {
        v359 = v353.getDate() + ". " + this.months[v353.getMonth()];
        v360 = v356.getDate() + ". " + this.months[v356.getMonth()];
      } else if (this.dateFormat === "dd_mm_no_dot") {
        v359 = v353.getDate() + " " + this.months[v353.getMonth()];
        v360 = v356.getDate() + " " + this.months[v356.getMonth()];
      } else if (this.dateFormat === "day_dd_mm_numeric") {
        const v361 = String(v353.getDate()).length > 1 ? v353.getDate() : "0" + v353.getDate();
        const v362 = String(v353.getMonth() + 1).length > 1 ? v353.getMonth() + 1 : "0" + (v353.getMonth() + 1);
        v359 = this.days[v353.getDay()] + ", " + v361 + ". " + v362 + ".";
        const v363 = String(v356.getDate()).length > 1 ? v356.getDate() : "0" + v356.getDate();
        const v364 = String(v356.getMonth() + 1).length > 1 ? v356.getMonth() + 1 : "0" + (v356.getMonth() + 1);
        v360 = this.days[v356.getDay()] + ", " + v363 + ". " + v364 + ".";
      } else if (this.dateFormat === "dd_mm_numeric") {
        const v365 = String(v353.getDate()).length > 1 ? v353.getDate() : "0" + v353.getDate();
        const v366 = String(v353.getMonth() + 1).length > 1 ? v353.getMonth() + 1 : "0" + (v353.getMonth() + 1);
        v359 = v365 + ". " + v366 + ".";
        const v367 = String(v356.getDate()).length > 1 ? v356.getDate() : "0" + v356.getDate();
        const v368 = String(v356.getMonth() + 1).length > 1 ? v356.getMonth() + 1 : "0" + (v356.getMonth() + 1);
        v360 = v367 + ". " + v368 + ".";
      } else {
        v359 = this.days[v353.getDay()] + ", " + this.months[v353.getMonth()] + " " + v353.getDate() + v354;
        v360 = this.days[v356.getDay()] + ", " + this.months[v356.getMonth()] + " " + v356.getDate() + v357;
      }
      const v369 = v350.replace("[start_date]", v359);
      const v370 = v369.replace("[end_date]", v360);
      v349.innerHTML = v370;
    });
  }
  rearrangeDays(v371) {
    v371.unshift(v371[6]);
    v371.length = 7;
    return v371;
  }
}
customElements.define("dynamic-dates", DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === "true";
    this.isScrollBtn = this.dataset.scrollBtn === "true";
    this.mainAtcBtn = document.querySelector("#ProductSubmitButton-" + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.isAfterScroll) {
      if (this.mainAtcBtn) {
        this.checkATCScroll();
        document.addEventListener("scroll", this.checkATCScroll.bind(this));
      }
    } else {
      this.floatingBtns.forEach(v372 => {
        v372.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector("" + this.dataset.scrollDestination.replace("id", this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
      }
    }
  }
  checkATCScroll() {
    if (window.scrollY > this.mainAtcBtn.offsetTop + this.mainAtcBtn.offsetHeight) {
      this.style.transform = "none";
      this.scrolledPast = true;
    } else {
      this.style.transform = "";
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach(v373 => {
      if (this.scrolledPast) {
        v373.style.setProperty("--sticky-atc-offset", this.offsetHeight + "px");
      } else {
        v373.style.setProperty("--sticky-atc-offset", "0px");
      }
    });
  }
  handleScrollBtn() {
    const v374 = document.querySelector("sticky-header");
    const v375 = v374 ? v374.clientHeight : 0;
    window.scrollTo({
      top: this.scrollDestination.offsetTop - v375 - 15,
      behavior: "smooth"
    });
  }
  footerSpacing() {
    let v376 = document.querySelector(".sticky-atc-footer-spacer");
    if (v376) {
      return;
    }
    v376 = document.createElement("div");
    v376.className = "sticky-atc-footer-spacer";
    v376.style.height = this.clientHeight - 1 + "px";
    v376.style.display = "block";
    const v377 = document.querySelector(".footer");
    if (v377) {
      v376.style.background = window.getComputedStyle(v377).background;
    }
    document.body.appendChild(v376);
  }
}
customElements.define("sticky-atc", StickyAtc);
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
    this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js");
    this.mediaItemImgs = this.querySelectorAll(".bundle-deals__media-item-img-js");
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
    this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js");
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.prices = this.querySelectorAll(".bundle-deals__price-js");
    this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js");
    this.totalPrice = this.querySelector(".bundle-deals__total-price-js");
    this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      id_1: null,
      id_2: null,
      id_3: null,
      id_4: null,
      id_5: null
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach(v378 => {
      v378.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach(v379 => {
      v379.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  initIds() {
    this.checkboxes.forEach(v380 => {
      this.selectedVariants[v380.dataset.idIndex] = {
        id: v380.dataset.id,
        price: v380.dataset.price,
        comparePrice: v380.dataset.comparePrice,
        checked: true
      };
    });
    this.updateFormIds();
  }
  handleCheckboxChange(v381) {
    const v382 = v381.currentTarget;
    const v383 = v382.checked;
    const v384 = parseInt(v382.dataset.index);
    this.selectedVariants[v382.dataset.idIndex].checked = v383;
    const v385 = this.productContainers[v384];
    const v386 = v385.querySelectorAll("select");
    if (v383) {
      this.mediaItemContainers[v384].classList.remove("bundle-deals__media-item--disabled");
      v385.classList.remove("bundle-deals__product--deselected");
      v386.forEach(v387 => {
        v387.removeAttribute("disabled");
      });
    } else {
      this.mediaItemContainers[v384].classList.add("bundle-deals__media-item--disabled");
      v385.classList.add("bundle-deals__product--deselected");
      v386.forEach(v388 => {
        v388.setAttribute("disabled", "");
      });
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }
  handleSelectChange(v389) {
    const v390 = v389.currentTarget;
    const v391 = parseInt(v390.dataset.index);
    const v392 = Array.from(v390.querySelectorAll("select"), v393 => v393.value);
    const v394 = JSON.parse(v390.querySelector("[type=\"application/json\"]").textContent).filter(v395 => v390.querySelector(":checked").value === v395.option1);
    const v396 = [...v390.querySelectorAll(".select--small")];
    updateVariantStatuses(v394, v396);
    const v397 = JSON.parse(v390.querySelector("[type=\"application/json\"]").textContent).find(v398 => {
      return !v398.options.map((v399, v400) => {
        return v392[v400] === v399;
      }).includes(false);
    });
    if (!v397) {
      if (this.skipNonExistent) {
        findAvailableVariant(v390, v392, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !v397.available) {
      if (findAvailableVariant(v390, v392, false, true, true)) {
        return;
      }
    }
    let {
      price: v401,
      compare_at_price: v402,
      featured_image: v403
    } = v397;
    v401 = parseInt(v401);
    let v404 = v402 ? parseInt(v402) : v401;
    const v405 = v390.dataset.percentageLeft ?? 1;
    const v406 = v390.dataset.fixedDiscount ?? 0;
    v401 = v401 * v405 - v406;
    if (v403) {
      v403 = v403.src;
    }
    const v407 = v397.id;
    this.selectedVariants[v390.dataset.idIndex].id = v407;
    this.selectedVariants[v390.dataset.idIndex].price = v401;
    this.selectedVariants[v390.dataset.idIndex].comparePrice = v404;
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[v391].innerHTML = this.currencySymbol + (v401 / 100).toFixed(2);
      if (v404 > v401) {
        this.comparePrices[v391].innerHTML = this.currencySymbol + (v404 / 100).toFixed(2);
      } else {
        this.comparePrices[v391].innerHTML = "";
      }
      this.updateTotalPrice();
    }
    if (v403 && v403.length > 0 && this.mediaItemImgs[v391]) {
      this.mediaItemImgs[v391].src = v403;
    }
  }
  updateFormIds() {
    const v408 = [];
    const v409 = this.selectedVariants;
    for (const v410 in v409) {
      const v411 = v409[v410];
      if (v411 != null && v411.checked) {
        const v412 = v408.findIndex(v413 => v413.id === v411.id);
        if (v412 < 0) {
          v408.unshift({
            id: v411.id,
            quantity: 1
          });
        } else {
          v408[v412].quantity += 1;
        }
      }
    }
    this.formVariants = v408;
  }
  updateTotalPrice() {
    const v414 = [];
    const v415 = [];
    const v416 = this.selectedVariants;
    for (const v417 in v416) {
      const v418 = v416[v417];
      if (v418 != null && v418.checked) {
        v414.push(parseInt(v418.price));
        v415.push(parseInt(v418.comparePrice));
      }
    }
    const v419 = v414.reduce((v420, v421) => v420 + v421, 0);
    const v422 = v419 * this.percentageLeft - this.fixedDiscount;
    const v423 = v415.reduce((v424, v425) => v424 + v425, 0);
    this.totalPrice.innerHTML = this.currencySymbol + (v422 / 100).toFixed(2);
    if (v423 > v422) {
      this.totalComparePrice.innerHTML = this.currencySymbol + (v423 / 100).toFixed(2);
    } else {
      this.totalComparePrice.innerHTML = "";
    }
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
    this.labels = this.querySelectorAll(".quantity-break");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      input_1: [],
      input_2: [],
      input_3: [],
      input_4: [],
      input_5: [],
      input_6: []
    };
    this.updateUnavailable = this.dataset.updateUnavailable === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.formVariants = [];
    this.selectedQuantity = 1;
    if (this.querySelector("input[checked]")) {
      this.selectedQuantity = parseInt(this.querySelector("input[checked]").value);
    }
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    if (this.hasVariants) {
      this.initVariants();
    }
    this.inputs.forEach(v426 => {
      v426.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach(v427 => {
      v427.addEventListener("change", this.handleSelectChange.bind(this));
    });
  }
  handleSelectChange(v428) {
    const v429 = v428.currentTarget;
    const v430 = Array.from(v429.querySelectorAll("select"), v431 => v431.value);
    if (this.updateUnavailable) {
      const v432 = this.getVariantData().filter(v433 => v429.querySelector(":checked").value === v433.option1);
      const v434 = [...v429.querySelectorAll(".select--small")];
      updateVariantStatuses(v432, v434);
    }
    const v435 = this.getVariantData().find(v436 => {
      return !v436.options.map((v437, v438) => {
        return v430[v438] === v437;
      }).includes(false);
    });
    if (!v435) {
      if (this.skipNonExistent) {
        findAvailableVariant(v429, v430, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !v435.available) {
      if (findAvailableVariant(v429, v430, false, true, true)) {
        return;
      }
    }
    v429.dataset.selectedId = v435.id;
    const v439 = v429.dataset.selectIndex;
    const v440 = v429.closest(".quantity-break");
    const v441 = v440.dataset.input;
    this.selectedVariants[v441][v439] = v435.id;
    this.formVariants = this.selectedVariants[v441];
    this.updateMedia(v435);
    if (!this.updatePrices) {
      return;
    }
    var v442 = 0;
    var v443 = 0;
    const v444 = parseFloat(v440.dataset.quantity);
    const v445 = parseFloat(v440.dataset.percentageLeft);
    const v446 = parseFloat(v440.dataset.fixedDiscount);
    for (let v447 = 0; v447 < v444; v447++) {
      const v448 = parseInt(this.selectedVariants[v441][v447]);
      const v449 = this.getVariantData().find(v450 => parseInt(v450.id) === v448);
      if (!v449) {
        return;
      }
      v442 += v449.price;
      if (v449.compare_at_price && v449.compare_at_price > v449.price) {
        v443 += v449.compare_at_price;
      } else {
        v443 += v449.price;
      }
    }
    v442 = v442 * v445 - v446;
    const v451 = v443 - v442;
    const v452 = Math.round(v451 / 100) * 100;
    const v453 = v442 / v444;
    const v454 = v443 / v444;
    const v455 = formatMoney(v442, this.moneyFormat, true);
    const v456 = formatMoney(v443, this.moneyFormat, true);
    const v457 = formatMoney(v451, this.moneyFormat, true);
    const v458 = formatMoney(v452, this.moneyFormat, true);
    const v459 = formatMoney(v453, this.moneyFormat, true);
    const v460 = formatMoney(v454, this.moneyFormat, true);
    v440.querySelectorAll(".variant-price-update").forEach(v461 => {
      let v462 = v461.dataset.text;
      v462 = v462.replace("[quantity]", v444);
      v462 = v462.replace("[price]", v455);
      v462 = v462.replace("[compare_price]", v456);
      v462 = v462.replace("[amount_saved]", v457);
      v462 = v462.replace("[amount_saved_rounded]", v458);
      v462 = v462.replace("[price_each]", v459);
      v462 = v462.replace("[compare_price_each]", v460);
      v461.innerHTML = v462;
    });
    const v463 = v440.querySelector(".quantity-break__compare-price");
    if (v463) {
      if (v443 > v442) {
        v463.classList.remove("hidden");
      } else {
        v463.classList.add("hidden");
      }
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  initVariants() {
    if (!this.hasVariants) {
      return;
    }
    this.labels.forEach(v464 => {
      if (v464.querySelector(".quantity-break__variants")) {
        let v465 = [];
        v464.querySelectorAll(".quantity-break__selector-item").forEach(v466 => {
          v465.push(v466.dataset.selectedId);
        });
        this.selectedVariants[v464.dataset.input] = v465;
      }
    });
    this.formVariants = [];
  }
  updateMedia(v467) {
    if (!v467) {
      return;
    }
    if (!v467.featured_media) {
      return;
    }
    const v468 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    v468.forEach(v469 => v469.setActiveMedia(this.dataset.section + "-" + v467.featured_media.id, true));
  }
  handleChange(v470) {
    const v471 = parseInt(v470.target.value);
    this.selectedQuantity = v471;
    if (this.hasVariants) {
      this.formVariants = this.selectedVariants[v470.target.dataset.input];
    }
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(v471);
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
function updateVariantStatuses(v472, v473) {
  v473.forEach((v474, v475) => {
    if (v475 === 0) {
      return;
    }
    const v476 = [...v474.querySelectorAll("option")];
    const v477 = v473[v475 - 1].querySelector(":checked").value;
    const v478 = v472.filter(v479 => v479.available && v479["option" + v475] === v477).map(v480 => v480["option" + (v475 + 1)]);
    const v481 = v472.filter(v482 => v482["option" + v475] === v477).map(v483 => v483["option" + (v475 + 1)]);
    v476.forEach(v484 => {
      v484.classList.remove("unavailable", "non-existent");
      if (v481.includes(v484.getAttribute("value"))) {
        if (v478.includes(v484.getAttribute("value"))) {
          v484.innerText = v484.getAttribute("value");
        } else {
          v484.innerText = window.variantStrings.unavailable_with_option.replace("[value]", v484.getAttribute("value"));
          v484.classList.add("unavailable");
        }
      } else {
        v484.innerText = window.variantStrings.unavailable_with_option.replace("[value]", v484.getAttribute("value"));
        v484.classList.add("non-existent");
      }
    });
  });
}
function findAvailableVariant(v485, v486, v487 = true, v488 = false, v489 = false) {
  for (let v490 = v486.length - 1; v490 >= 0; v490--) {
    const v491 = v487 ? v485.querySelector(".product-form__input:nth-child(" + (v490 + 1) + ")") : v485.querySelectorAll(".select")[v490];
    const v492 = v487 ? v491.querySelector(".product-form__input__type").dataset.type : "dropdown";
    const v493 = v492 === "dropdown" ? v491.querySelectorAll("option") : v491.querySelectorAll("input[type=\"radio\"]");
    let v494 = Array.from(v493).findIndex(v495 => v495.value === v486[v490]);
    let v496 = false;
    while (v494 < v493.length - 1) {
      v494++;
      const v497 = v493[v494];
      if ((!v488 || !v497.classList.contains("non-existent")) && (!v489 || !v497.classList.contains("unavailable"))) {
        v486[v490] = v497.value;
        v496 = true;
        break;
      }
    }
    if (!v496) {
      v494 = Array.from(v493).findIndex(v498 => v498.value === v486[v490]);
      while (v494 > 0) {
        v494--;
        const v499 = v493[v494];
        if ((!v488 || !v499.classList.contains("non-existent")) && (!v489 || !v499.classList.contains("unavailable"))) {
          v486[v490] = v499.value;
          v496 = true;
          break;
        }
      }
    }
    if (v496) {
      if (v492 === "dropdown") {
        v491.querySelector(".select__select").value = v486[v490];
      } else {
        v491.querySelector("input[type=\"radio\"][value=\"" + v486[v490] + "\"]").checked = true;
      }
      v485.dispatchEvent(new Event("change"));
      return true;
    }
  }
  return false;
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
    this.unlockedItems = [];
    this.initUnlock();
  }
  initUnlock() {
    let v500 = 1;
    if (this.quantityBreaks) {
      v500 = parseInt(this.quantityBreaks.selectedQuantity);
    } else if (this.quantitySelector) {
      const v501 = this.quantitySelector.querySelector("input[name=\"quantity\"]");
      v500 = parseInt(v501.value);
    }
    this.unlockGifts(v500);
  }
  unlockGifts(v502) {
    this.unlockedItems = [];
    this.gifts.forEach(v503 => {
      if (parseInt(v503.dataset.quantity) <= v502) {
        v503.classList.add("quantity-gift--unlocked");
        v503.dataset.unlocked = "true";
        if (v503.dataset.product) {
          this.unlockedItems.unshift(v503.dataset.product);
        }
      } else {
        v503.classList.remove("quantity-gift--unlocked");
        v503.dataset.unlocked = "false";
      }
    });
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector(".upsell__image__img");
    this.toggleBtn = this.querySelector(".upsell-toggle-btn");
    this.variantSelects = this.querySelector(".upsell__variant-picker");
    this.variantSelectElements = this.querySelectorAll(".select__select");
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.productForm = this.querySelector("product-form");
    if (this.productForm) {
      this.idInput = this.productForm.querySelector("[name=\"id\"]");
    }
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector(".upsell__price .regular-price");
      this.comparePriceSpan = this.querySelector(".upsell__price .compare-price");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === "true";
      if (this.isMainOfferItem) {
        this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
      }
    }
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    }
    if (this.variantSelects) {
      this.variantSelects.addEventListener("change", this.handleSelectChange.bind(this));
    }
  }
  handleToggle(v504) {
    if (v504.target.nodeName.toLowerCase() === "select" || v504.target.nodeName.toLowerCase() === "option") {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
    } else {
      this.dataset.selected = "true";
    }
  }
  handleSelectChange(v505) {
    const v506 = v505.currentTarget;
    const v507 = Array.from(v506.querySelectorAll("select"), v508 => v508.value);
    const v509 = this.getVariantData().find(v510 => {
      return !v510.options.map((v511, v512) => {
        return v507[v512] === v511;
      }).includes(false);
    });
    const v513 = this.getVariantData().filter(v514 => v506.querySelector(":checked").value === v514.option1);
    const v515 = [...v506.querySelectorAll("select")];
    updateVariantStatuses(v513, v515);
    if (!v509) {
      if (this.skipNonExistent) {
        findAvailableVariant(v506, v507, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !v509.available) {
      if (findAvailableVariant(v506, v507, false, true, true)) {
        return;
      }
    }
    if (this.updatePrices) {
      this.price = v509.price * this.percentageLeft - this.fixedDiscount;
      this.comparePrice = v509.price;
      if (v509.compare_at_price && v509.compare_at_price > v509.price) {
        this.comparePrice = v509.compare_at_price;
      }
      displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
    }
    if (this.image && v509.featured_image) {
      this.image.src = v509.featured_image.src;
    }
    this.updateId(v509.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) {
      this.mainOfferContainer.updateTotalPrices();
    }
  }
  updateId(v516) {
    this.dataset.id = v516;
    if (this.idInput) {
      this.idInput.value = v516;
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartItems = this.cartDrawer.querySelector("cart-drawer-items");
    this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  handleToggle(v517) {
    if (v517.target.nodeName.toLowerCase() === "select" || v517.target.nodeName.toLowerCase() === "option") {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = "false";
      this.removeFromCart();
    } else {
      this.dataset.selected = "true";
      this.addToCart();
    }
  }
  addRemoveFromCart() {
    if (this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty")) {
      this.addToCart();
    } else {
      this.removeFromCart();
    }
  }
  addToCart() {
    const v518 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (v518) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach(v519 => {
      v519.setAttribute("disabled", "");
    });
    this.productForm.handleSubmit();
  }
  removeFromCart() {
    const v520 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!v520 || !this.cartItems) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", "");
    }
    this.variantSelectElements.forEach(v521 => {
      v521.setAttribute("disabled", "");
    });
    this.cartItems.updateQuantity(v520.dataset.index, 0);
  }
  updateId(v522) {
    this.dataset.id = v522;
    this.idInput.value = v522;
    if (this.classicAddButton) {
      return;
    }
    if (this.dataset.selected === "true") {
      if (this.selectTimeout) {
        clearTimeout(this.selectTimeout);
      }
      this.removeFromCart();
      const v523 = v524 => {
        if (v524.detail.handle === "handle") {
          this.addToCart();
          document.removeEventListener("cartQuantityUpdated", v523);
        }
      };
      document.addEventListener("cartQuantityUpdated", v523);
    }
  }
  getUpdateRequired() {
    const v525 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    let v526 = false;
    if (v525 && this.dataset.selected === "false") {
      v526 = true;
    } else if (!v525 && this.dataset.selected === "true") {
      v526 = true;
    }
    return v526;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(v527, v528, v529, v530, v531) {
  if (!v531) {
    return;
  }
  if (v527 && v529) {
    var v532 = formatMoney(v527, v531);
    v529.innerHTML = v532;
  }
  if (v528 && v530) {
    var v533 = formatMoney(v528, v531);
    v530.innerHTML = v533;
    if (v528 > v527) {
      v530.classList.remove("hidden");
    } else {
      v530.classList.add("hidden");
    }
  }
}
function formatMoney(v534, v535, v536 = false) {
  if (typeof v534 == "string") {
    v534 = v534.replace(".", "");
  }
  var v537 = "";
  var v538 = /\{\{\s*(\w+)\s*\}\}/;
  var v539 = v535;
  function v540(v541, v542) {
    if (typeof v541 == "undefined") {
      return v542;
    } else {
      return v541;
    }
  }
  function v543(v544, v545, v546, v547) {
    v545 = v540(v545, 2);
    v546 = v540(v546, ",");
    v547 = v540(v547, ".");
    if (isNaN(v544) || v544 == null) {
      return 0;
    }
    v544 = (v544 / 100).toFixed(v545);
    var v548 = v544.split(".");
    var v549 = v548[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + v546);
    var v550 = v548[1] ? v547 + v548[1] : "";
    if (v536 && v550 === v547 + "00") {
      v550 = "";
    }
    return v549 + v550;
  }
  switch (v539.match(v538)[1]) {
    case "amount":
      v537 = v543(v534, 2);
      break;
    case "amount_no_decimals":
      v537 = v543(v534, 0);
      break;
    case "amount_with_comma_separator":
      v537 = v543(v534, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      v537 = v543(v534, 0, ".", ",");
      break;
  }
  return v539.replace(v538, v537);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const v551 = document.querySelector("cart-drawer");
  if (v551) {
    v551.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(v552 => {
      if (v552.addRemoveFromCart) {
        v552.addRemoveFromCart();
      }
    });
  }
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll(".main-offer-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.priceSpan = this.querySelector(".bundle-deals__total-price-js");
      this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
    }
  }
  updateTotalPrices() {
    if (!this.updatePrices) {
      return;
    }
    var v553 = 0;
    var v554 = 0;
    for (let v555 = 0; v555 < this.offerItems.length; v555++) {
      v553 += parseInt(this.offerItems[v555].price);
      v554 += parseInt(this.offerItems[v555].comparePrice);
    }
    v553 = v553 * this.percentageLeft - this.fixedDiscount;
    displayPrices(v553, v554, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea");
    this.inputRadios = this.querySelectorAll("[type=\"radio\"]");
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById("product-form-" + this.dataset.section);
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === "true";
    this.isText = true;
    this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") {
      this.isText = false;
    }
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true;
      this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll(".main-product-atc");
      this.mainAtcButton = this.productForm.querySelector("#ProductSubmitButton-" + this.dataset.section);
      this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
      this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 1;
      this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
      this.stickyAtcButton = document.querySelector("#sticky-atc-" + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) {
      this.input.addEventListener("input", this.handleChange.bind(this));
    }
    this.inputRadios.forEach(v556 => {
      v556.addEventListener("input", this.handleChange.bind(this));
    });
    if (this.select) {
      this.select.addEventListener("change", this.handleChange.bind(this));
    }
  }
  handleChange(v557) {
    const v558 = v557.target.value.trim();
    if (v557.target.checkValidity()) {
      this.prevValue = v558;
    } else {
      v557.target.value = this.prevValue;
      return;
    }
    this.dataset.value = v558;
    this.productFormInput.value = v558;
    if (this.isRequired && this.isText) {
      this.validateValue(v558, v557.target);
    }
  }
  validateValue(v559, v560) {
    const v561 = v559.length > 0 ? true : false;
    if (v561 === this.isValid) {
      return;
    }
    this.isValid = v561;
    if (v560) {
      if (this.isValid) {
        v560.classList.remove("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 1;
      } else {
        v560.classList.add("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 1;
      }
    }
    const v562 = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
    const v563 = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(v564 => {
      if (v562 && !v563) {
        v564.removeAttribute("disabled");
      } else {
        v564.setAttribute("disabled", "");
      }
    });
    if (this.atcErrorMsg.length === 0) {
      return;
    }
    if (v562) {
      this.mainAtcBtnLabel.style.display = "";
      this.mainAtcBtnError.style.display = "none";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "";
        this.stickyAtcBtnError.style.display = "none";
      }
    } else {
      this.mainAtcBtnLabel.style.display = "none";
      this.mainAtcBtnError.style.display = "";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "none";
        this.stickyAtcBtnError.style.display = "";
      }
    }
  }
  createInputs() {
    this.productFormInput = document.createElement("input");
    this.productFormInput.setAttribute("type", "hidden");
    this.productFormInput.setAttribute("name", "properties[" + this.fieldName + "]");
    this.productFormInput.value = this.dataset.defaultValue;
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = "StickyAtcVariantPicker-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true";
    this.prependMedia = this.dataset.disablePrepend != "true";
    this.filtering = this.dataset.hasFiltering === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    if (this.hasQuantityBreaksPicker) {
      this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
      this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages;
    }
    this.addEventListener("change", this.onVariantChange);
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) {
        return;
      }
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) {
          return;
        }
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  updateOptions() {
    const v565 = [];
    this.querySelectorAll(".product-form__input").forEach(v566 => {
      let v567;
      const v568 = v566.querySelector(".product-form__input__type").dataset.type;
      if (v568 == "dropdown" || v568 == "dropdwon") {
        v567 = v566.querySelector(".select__select").value;
      } else {
        v567 = v566.querySelector("input[type=\"radio\"]:checked").value;
      }
      v565.push(v567);
    });
    this.options = v565;
  }
  updateMasterId() {
    this.currentVariant = this.getVariantData().find(v569 => {
      return !v569.options.map((v570, v571) => {
        return this.options[v571] === v570;
      }).includes(false);
    });
  }
  updateMedia() {
    if (!this.currentVariant) {
      return;
    }
    if (!this.currentVariant.featured_media) {
      return;
    }
    const v572 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    v572.forEach(v573 => v573.setActiveMedia(this.dataset.section + "-" + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
    const v574 = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!v574) {
      return;
    }
    const v575 = v574.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
    v574.prepend(v575);
  }
  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") {
      return;
    }
    window.history.replaceState({}, "", this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateShareUrl() {
    const v576 = document.getElementById("Share-" + this.dataset.section);
    if (!v576 || !v576.updateUrl) {
      return;
    }
    v576.updateUrl("" + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  updateVariantInput() {
    const v577 = document.querySelectorAll("#product-form-" + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    v577.forEach(v578 => {
      const v579 = v578.querySelector("input[name=\"id\"]");
      v579.value = this.currentVariant.id;
      v579.dispatchEvent(new Event("change", {
        bubbles: true
      }));
    });
  }
  updateVariantStatuses() {
    const v580 = this.variantData.filter(v581 => this.querySelector(":checked").value === v581.option1);
    let v582;
    if (this.isSecondary && this.secondarySelect) {
      v582 = [...this.secondarySelect.querySelectorAll(".product-form__input")];
    } else {
      v582 = [...this.querySelectorAll(".product-form__input")];
    }
    v582.forEach((v583, v584) => {
      if (v584 === 0) {
        return;
      }
      const v585 = [...v583.querySelectorAll("input[type=\"radio\"], .select__select option")];
      const v586 = v582[v584 - 1].querySelector(":checked").value;
      const v587 = v580.filter(v588 => v588.available && v588["option" + v584] === v586).map(v589 => v589["option" + (v584 + 1)]);
      const v590 = v580.filter(v591 => v591["option" + v584] === v586).map(v592 => v592["option" + (v584 + 1)]);
      this.setInputAvailability(v585, v587, v590);
    });
  }
  setInputAvailability(v593, v594, v595) {
    v593.forEach(v596 => {
      v596.classList.remove("unavailable", "non-existent", "disabled");
      const v597 = v596.getAttribute("value");
      let v598 = null;
      if (v596.dataset.swatch === "true") {
        v598 = v596.closest(".color-swatch");
      }
      if (v598) {
        v598.classList.remove("unavailable", "non-existent", "disabled");
      }
      if (v595.includes(v597)) {
        if (v594.includes(v597)) {
          if (v596.nodeName === "OPTION") {
            v596.innerText = v597;
          } else {
            v596.classList.remove("disabled");
            if (v598) {
              v598.classList.remove("disabled");
            }
          }
        } else if (v596.nodeName === "OPTION") {
          v596.innerText = window.variantStrings.unavailable_with_option.replace("[value]", v597);
          v596.classList.add("unavailable");
        } else {
          v596.classList.add("disabled", "unavailable");
          if (v598) {
            v598.classList.add("disabled", "unavailable");
          }
        }
      } else if (v596.nodeName === "OPTION") {
        v596.innerText = window.variantStrings.unavailable_with_option.replace("[value]", v597);
        v596.classList.add("non-existent");
      } else {
        v596.classList.add("disabled", "non-existent");
        if (v598) {
          v598.classList.add("disabled", "non-existent");
        }
      }
    });
  }
  updatePickupAvailability() {
    const v599 = document.querySelector("pickup-availability");
    if (!v599) {
      return;
    }
    if (this.currentVariant && this.currentVariant.available) {
      if (v599.fetchAvailability) {
        v599.fetchAvailability(this.currentVariant.id);
      }
    } else {
      v599.removeAttribute("available");
      v599.innerHTML = "";
    }
  }
  removeErrorMessage() {
    const v600 = this.closest("section");
    if (!v600) {
      return;
    }
    const v601 = v600.querySelector("product-form");
    if (v601) {
      v601.handleErrorMessage();
    }
  }
  renderProductInfo() {
    const v602 = this.currentVariant.id;
    const v603 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + v602 + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(v604 => v604.text()).then(v605 => {
      if (this.currentVariant.id !== v602) {
        return;
      }
      const v606 = new DOMParser().parseFromString(v605, "text/html");
      const v607 = document.getElementById("price-" + this.dataset.section);
      const v608 = v606.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const v609 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section);
      const v610 = v606.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const v611 = document.getElementById("sticky-atc-price-" + this.dataset.section);
      const v612 = v606.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const v613 = document.getElementById("sticky-atc-image-" + this.dataset.section);
      const v614 = v606.getElementById("sticky-atc-image-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const v615 = document.getElementById("main-atc-price-" + this.dataset.section);
      const v616 = v606.getElementById("main-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const v617 = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]");
      const v618 = v606.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]");
      const v619 = v606.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const v620 = document.getElementById("Sku-" + this.dataset.section);
      const v621 = v606.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const v622 = document.getElementById("Inventory-" + this.dataset.section);
      if (v607 && v608) {
        v607.innerHTML = v608.innerHTML;
      }
      if (v609 && v610) {
        v609.innerHTML = v610.innerHTML;
      }
      if (v611 && v612) {
        v611.innerHTML = v612.innerHTML;
      }
      if (v613 && v614) {
        v613.src = v614.src;
      }
      if (v616 && v615) {
        v615.innerHTML = v616.innerHTML;
      }
      if (v617 && v618) {
        for (var v623 = 0; v623 < v617.length; v623++) {
          v617[v623].innerHTML = v618[v623].innerHTML;
        }
      }
      if (v621 && v622) {
        v622.innerHTML = v621.innerHTML;
      }
      if (v619 && v620) {
        v620.innerHTML = v619.innerHTML;
        v620.classList.toggle("visibility-hidden", v619.classList.contains("visibility-hidden"));
      }
      if (this.QuantityBreaks) {
        const v624 = v606.getElementById("quantity-breaks-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const v625 = this.QuantityBreaks.querySelectorAll(".dynamic-price");
        const v626 = v624.querySelectorAll(".dynamic-price");
        for (let v627 = 0; v627 < v625.length; v627++) {
          v625[v627].innerHTML = v626[v627].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach(v628 => {
            v628.dataset.selectedId = this.currentVariant.id;
          });
          const v629 = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select");
          const v630 = v624.querySelectorAll(".quantity-break__variant-select");
          for (let v631 = 0; v631 < v629.length; v631++) {
            v629[v631].innerHTML = v630[v631].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        }
      }
      if (this.hasQuantityBreaksPicker) {
        const v632 = v606.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const v633 = this.querySelectorAll(".dynamic-price");
        const v634 = v632.querySelectorAll(".dynamic-price");
        for (let v635 = 0; v635 < v633.length; v635++) {
          v633[v635].innerHTML = v634[v635].innerHTML;
        }
        if (this.quantityBreaksPickerStyle === "vertical" && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          const v636 = this.querySelectorAll(".quantity-break__image img");
          const v637 = v632.querySelectorAll(".quantity-break__image img");
          for (let v638 = 0; v638 < v636.length; v638++) {
            v636[v638].src = v637[v638].src;
          }
        }
      }
      if (this.secondarySelect) {
        const v639 = v606.getElementById("" + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (v639) {
          this.secondarySelect.innerHTML = v639.innerHTML;
        }
      }
      const v640 = document.getElementById("price-" + this.dataset.section);
      if (v640) {
        v640.classList.remove("visibility-hidden");
      }
      this.dataset.options = this.currentVariant.options.join(",");
      if (v622) {
        v622.classList.toggle("visibility-hidden", v621.innerText === "");
      }
      const v641 = v606.getElementById("ProductSubmitButton-" + v603);
      this.toggleAddButton(v641 ? v641.hasAttribute("disabled") : true, window.variantStrings.soldOut);
      publish(PUB_SUB_EVENTS.variantChange, {
        data: {
          sectionId: v603,
          html: v606,
          variant: this.currentVariant
        }
      });
    });
  }
  toggleAddButton(v642 = true, v643, v644 = true) {
    const v645 = document.getElementById("product-form-" + this.dataset.section);
    if (!v645) {
      return;
    }
    const v646 = v645.querySelector("[name=\"add\"]");
    const v647 = document.querySelectorAll(".main-product-atc");
    var v648 = v645.querySelector(".main-atc__label__text");
    if (!v648) {
      v648 = v645.querySelector(".main-atc__label");
    }
    const v649 = v645.querySelector(".main-atc-price");
    if (!v646) {
      return;
    }
    if (v642) {
      v646.setAttribute("disabled", "disabled");
      v646.setAttribute("data-unavailable", "true");
      if (v643) {
        v648.textContent = v643;
      }
      v647.forEach(v650 => {
        v650.setAttribute("disabled", "disabled");
      });
      if (v649) {
        v649.classList.add("hidden");
      }
    } else {
      v646.setAttribute("data-unavailable", "false");
      v648.textContent = window.variantStrings.addToCart;
      if (v649) {
        v649.classList.remove("hidden");
      }
      if (v646.dataset.requiredFields === v646.dataset.validFields) {
        v646.removeAttribute("disabled");
        v647.forEach(v651 => {
          v651.removeAttribute("disabled");
        });
      }
    }
    if (!v644) {
      return;
    }
  }
  setUnavailable() {
    const v652 = document.getElementById("product-form-" + this.dataset.section);
    if (!v652) {
      return;
    }
    const v653 = v652.querySelector("[name=\"add\"]");
    var v654 = v652.querySelector(".main-atc__label__text");
    if (!v654) {
      v654 = v652.querySelector(".main-atc__label");
    }
    const v655 = document.getElementById("price-" + this.dataset.section);
    const v656 = document.getElementById("Inventory-" + this.dataset.section);
    const v657 = document.getElementById("Sku-" + this.dataset.section);
    if (!v653) {
      return;
    }
    v654.textContent = window.variantStrings.unavailable;
    if (v655) {
      v655.classList.add("visibility-hidden");
    }
    if (v656) {
      v656.classList.add("visibility-hidden");
    }
    if (v657) {
      v657.classList.add("visibility-hidden");
    }
  }
  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
  updateOptions() {
    this.options = this.querySelector("select").value.split(",");
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById("" + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
}
customElements.define("secondary-variant-select-separate", SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
  }
  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateQuickAddUrl();
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }
  }
  updateMedia() {
    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }
    const v658 = document.getElementById(this.dataset.section + "-image");
    if (!v658) {
      return;
    }
    const v659 = this.currentVariant.featured_media.preview_image;
    const v660 = v659.src.split("?")[0];
    const v661 = [165, 360, 533, 720, 940, 1066];
    const v662 = v661.filter(v663 => v659.width >= v663).map(v664 => v660 + "?width=" + v664 + " " + v664 + "w").join(", ");
    v658.srcset = v662 + ", " + v660 + " " + v659.width + "w";
    v658.src = v660 + "?width=533";
  }
  updateQuickAddUrl() {
    if (!this.currentVariant || !this.quickAddSubmit) {
      return;
    }
    this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);